import React, { useContext, useEffect, useState } from 'react';
import { Typography, Button, Input, Spinner } from "@material-tailwind/react";
import CreatableSelect from 'react-select/creatable';
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { update_sms_regex } from '../../Controller/actions';
import { toast } from 'react-toastify';

export const SmsRegexModel = ({ getSmsData }) => {
    const { isModalLoading, handleClose, handleChange, formData, open, addEditDeleteTag, setIsModalLoading, setFormData } = useContext(NewContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createupdateAsset;
        setIsModalLoading(true);

        if (addEditDeleteTag === "update") {
            createupdateAsset = await update_sms_regex({ ...formData }, formData?._id);
            getSmsData();
        } else {
            // createupdateAsset = await add_asset({ ...formData, title: selectedAssetOptions.value });
        }
        setIsModalLoading(false);
        if (createupdateAsset) {
            const { message, status } = createupdateAsset;
            if (status) {
                toast.success(message);
                setFormData([]);
                handleClose();
            } else {
                toast.error(message);
            }
        }
        handleClose();
    };

    // useEffect(() => {
    //     setFormData({ ...formData });
    // }, [setFormData]);

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { handleClose(); }}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            height: "100%",
                            maxWidth: "500px",
                            maxHeight: "700px",
                            borderRadius: "12px"
                        },
                    },
                }} >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit SMS Regex` : `Add SMS Regex`
                    }
                </DialogTitle>
                <DialogContent>
                    <div>
                        {
                            addEditDeleteTag !== 'view' ?
                                <form onSubmit={handleSubmit}>
                                    <div className="mt-5 grid grid-cols-1 lg:grid-cols-6 gap-5 add-edit-form">
                                        <div className="sm:col-span-6">
                                            <label htmlFor="countryCode" className="block  font-medium leading-5 mt-4">Country:</label>
                                            <div className="mt-2">
                                                <Input id='countryCode' required placeholder='Enter countryCode' name='countryCode' onChange={handleChange} value={formData?.countryCode} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="language_code" className="block  font-medium leading-5 mt-4">language Code:</label>
                                            <div className="mt-2">
                                                <Input id='language_code' required placeholder='Enter language Code' name='language_code' onChange={handleChange} value={formData?.language_code} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="credit_transaction" className="block  font-medium leading-5 mt-4">Credit Transaction:</label>
                                            <div className="mt-2">
                                                <Input id='credit_transaction' required placeholder='Enter credit Transaction' name='credit_transaction' onChange={handleChange} value={formData?.credit_transaction} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="debit_transaction" className="block  font-medium leading-5 mt-4">Debit Transaction:</label>
                                            <div className="mt-2">
                                                <Input id='debit_transaction' required placeholder='Enter Debit Transaction' name='debit_transaction' onChange={handleChange} value={formData?.debit_transaction} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="promotion" className="block  font-medium leading-5 mt-4">promotion:</label>
                                            <div className="mt-2">
                                                <Input id='promotion' required placeholder='Enter Promotion' name='promotion' onChange={handleChange} value={formData?.promotion} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="otp" className="block  font-medium leading-5 mt-4">OTP:</label>
                                            <div className="mt-2">
                                                <Input id='otp' required placeholder='Enter otp' name='otp' onChange={handleChange} value={formData?.otp} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="transaction" className="block  font-medium leading-5 mt-4">Transaction:</label>
                                            <div className="mt-2">
                                                <Input id='transaction' required placeholder='Enter transaction' name='transaction' onChange={handleChange} value={formData?.transaction} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="account_no" className="block  font-medium leading-5 mt-4">Account No:</label>
                                            <div className="mt-2">
                                                <Input id='account_no' required placeholder='Enter account_no' name='account_no' onChange={handleChange} value={formData?.account_no} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="transaction_amount" className="block  font-medium leading-5 mt-4">Transaction Amount:</label>
                                            <div className="mt-2">
                                                <Input id='transaction_amount' required placeholder='Enter transaction_amount' name='transaction_amount' onChange={handleChange} value={formData?.transaction_amount} autoComplete='off' />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="amount_symbol" className="block  font-medium leading-5 mt-4">Amount Symbol:</label>
                                            <div className="mt-2">
                                                <Input id='amount_symbol' required placeholder='Enter amount_symbol' name='amount_symbol' onChange={handleChange} value={formData?.amount_symbol} autoComplete='off' />
                                            </div>
                                        </div>

                                    </div>
                                    <div className='flex justify-end mt-24'>
                                        <Button onClick={() => { handleClose() }} className="mr-1 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                        >
                                            <span>Cancel</span>
                                        </Button>
                                        <Button className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                            type='submit'
                                        >
                                            {isModalLoading && <Spinner className="h-4 w-4" />}
                                            <span className={isModalLoading && 'ml-4'}>{addEditDeleteTag === `add` ? `Add` : `Update`}</span>
                                        </Button>
                                    </div>
                                </form>
                                :
                                <div>
                                </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>
            {/* <BackgroundChildModal /> */}
        </>
    )
}

export default SmsRegexModel;
